export enum EnumContratoConfig {
    TamanhoCodigoProduto = 117,
    TipoFinalCodigo = 118,
    ClientePadrao = 326,
    ProdutoGenerico = 910,
    ProdutoServico = 814,
    DataUltimoCadastro = 1,
    PermitirRepeticaoCodigo = 7,
    ProdutoEntrega = 8001,
}